export const getGenericYesOrNo = () => {
  return [
    { name: 'Yes', value: 'Yes' },
    { name: 'No', value: 'No' }
  ]
}

export const getGenericSalutationTypes = () => {
  return [
    { name: 'Mr.', value: 'Mr.' },
    { name: 'Ms.', value: 'Ms.' }
  ]
}

export function getCountries() {
    return [
      {name: " PH - Philippines ", value: "PH - Philippines "},
      {name: " CN - China ", value: " CN - China "},
      {name: " US - United States ", value: " US - United States "},
      {name: " CA - Canada ", value: " CA - Canada "},
      {name: " AF - Afghanistan ", value: " AF - Afghanistan "},
      {name: " AL - Albania ", value: " AL - Albania "},
      {name: " DZ - Algeria ", value: " DZ - Algeria "},
      {name: " AS - American Samoa ", value: " AS - American Samoa "},
      {name: " AD - Andorra ", value: " AD - Andorra "},
      {name: " AO - Angola ", value: " AO - Angola "},
      {name: " AI - Anguilla ", value: " AI - Anguilla "},
      {name: " AQ - Antarctica ", value: " AQ - Antarctica "},
      {name: " AG - Antigua and Barbuda ", value: " AG - Antigua and Barbuda "},
      {name: " AR - Argentina ", value: " AR - Argentina "},
      {name: " AM - Armenia ", value: " AM - Armenia "},
      {name: " AW - Aruba ", value: " AW - Aruba "},
      {name: " AU - Australia ", value: " AU - Australia "},
      {name: " AT - Austria ", value: " AT - Austria "},
      {name: " AZ - Azerbaijan ", value: " AZ - Azerbaijan "},
      {name: " BS - Bahamas ", value: " BS - Bahamas "},
      {name: " BH - Bahrain ", value: " BH - Bahrain "},
      {name: " BD - Bangladesh ", value: " BD - Bangladesh "},
      {name: " BY - Belarus ", value: " BY - Belarus "},
      {name: " BE - Belgium ", value: " BE - Belgium "},
      {name: " BZ - Belize ", value: " BZ - Belize "},
      {name: " BJ - Benin ", value: " BJ - Benin "},
      {name: " BM - Bermuda ", value: " BM - Bermuda "},
      {name: " BT - Bhutan ", value: " BT - Bhutan "},
      {name: " BO - Bolivia ", value: " BO - Bolivia "},
      {name: " BA - Bosnia-Herzegovina ", value: " BA - Bosnia-Herzegovina "},
      {name: " BW - Botswana ", value: " BW - Botswana "},
      {name: " BV - Bouvet Island ", value: " BV - Bouvet Island "},
      {name: " BR - Brazil ", value: " BR - Brazil "},
      {name: " IO - British Indian Ocean Territories ", value: " IO - British Indian Ocean Territories "},
      {name: " BN - Brunei Darussalam ", value: " BN - Brunei Darussalam "},
      {name: " BG - Bulgaria ", value: " BG - Bulgaria "},
      {name: " BF - Burkina Faso ", value: " BF - Burkina Faso "},
      {name: " BI - Burundi ", value: " BI - Burundi "},
      {name: " KH - Cambodia ", value: " KH - Cambodia "},
      {name: " CM - Cameroon ", value: " CM - Cameroon "},
      {name: " CV - Cape Verde ", value: " CV - Cape Verde "},
      {name: " KY - Cayman Islands ", value: " KY - Cayman Islands "},
      {name: " CF - Central African Republic ", value: " CF - Central African Republic "},
      {name: " TD - Chad ", value: " TD - Chad "},
      {name: " CL - Chile ", value: " CL - Chile "},
      {name: " CX - Christmas Island ", value: " CX - Christmas Island "},
      {name: " CC - Cocos (Keeling) Islands ", value: " CC - Cocos (Keeling) Islands "},
      {name: " CO - Colombia ", value: " CO - Colombia "},
      {name: " KM - Comoros ", value: " KM - Comoros "},
      {name: " CD - Congo, Democratic Rep. ", value: " CD - Congo, Democratic Rep. "},
      {name: " CG - Congo, Republic of ", value: " CG - Congo, Republic of "},
      {name: " CK - Cook Islands ", value: " CK - Cook Islands "},
      {name: " CR - Costa Rica ", value: " CR - Costa Rica "},
      {name: " HR - Croatia ", value: " HR - Croatia "},
      {name: " CU - Cuba ", value: " CU - Cuba "},
      {name: " CY - Cyprus ", value: " CY - Cyprus "},
      {name: " CZ - Czech Republic ", value: " CZ - Czech Republic "},
      {name: " CS - Czechoslovakia ", value: " CS - Czechoslovakia "},
      {name: " DK - Denmark ", value: " DK - Denmark "},
      {name: " DJ - Djibouti ", value: " DJ - Djibouti "},
      {name: " DM - Dominica ", value: " DM - Dominica "},
      {name: " DO - Dominican Republic ", value: " DO - Dominican Republic "},
      {name: " TP - East Timor ", value: " TP - East Timor "},
      {name: " EC - Ecuador ", value: " EC - Ecuador "},
      {name: " EG - Egypt ", value: " EG - Egypt "},
      {name: " SV - El Salvador ", value: " SV - El Salvador "},
      {name: " GQ - Equatorial Guinea ", value: " GQ - Equatorial Guinea "},
      {name: " ER - Eritrea ", value: " ER - Eritrea "},
      {name: " EE - Estonia ", value: " EE - Estonia "},
      {name: " ET - Ethiopia ", value: " ET - Ethiopia "},
      {name: " FK - Falkland Islands (Malvinas) ", value: " FK - Falkland Islands (Malvinas) "},
      {name: " FO - Faroe Islands ", value: " FO - Faroe Islands "},
      {name: " FJ - Fiji ", value: " FJ - Fiji "},
      {name: " FI - Finland ", value: " FI - Finland "},
      {name: " FR - France ", value: " FR - France "},
      {name: " FX - France (European Territories) ", value: " FX - France (European Territories) "},
      {name: " TF - French Southern Territories ", value: " TF - French Southern Territories "},
      {name: " GA - Gabon ", value: " GA - Gabon "},
      {name: " GM - Gambia ", value: " GM - Gambia "},
      {name: " GE - Georgia ", value: " GE - Georgia "},
      {name: " DE - Germany ", value: " DE - Germany "},
      {name: " GH - Ghana ", value: " GH - Ghana "},
      {name: " GI - Gibraltar ", value: " GI - Gibraltar "},
      {name: " GB - Great Britain (UK) ", value: " GB - Great Britain (UK) "},
      {name: " GR - Greece ", value: " GR - Greece "},
      {name: " GL - Greenland ", value: " GL - Greenland "},
      {name: " GD - Grenada ", value: " GD - Grenada "},
      {name: " GP - Guadeloupe (Fr.) ", value: " GP - Guadeloupe (Fr.) "},
      {name: " GU - Guam (US) ", value: " GU - Guam (US) "},
      {name: " GT - Guatemala ", value: " GT - Guatemala "},
      {name: " GF - Guiana (Fr.) ", value: " GF - Guiana (Fr.) "},
      {name: " GN - Guinea ", value: " GN - Guinea "},
      {name: " GW - Guinea Bissau ", value: " GW - Guinea Bissau "},
      {name: " GY - Guyana ", value: " GY - Guyana "},
      {name: " HT - Haiti ", value: " HT - Haiti "},
      {name: " HM - Heard & McDonald Islands ", value: " HM - Heard & McDonald Islands "},
      {name: " HN - Honduras ", value: " HN - Honduras "},
      {name: " HK - Hong Kong ", value: " HK - Hong Kong "},
      {name: " HU - Hungary ", value: " HU - Hungary "},
      {name: " IS - Iceland ", value: " IS - Iceland "},
      {name: " IN - India ", value: " IN - India "},
      {name: " ID - Indonesia ", value: " ID - Indonesia "},
      {name: " IR - Iran ", value: " IR - Iran "},
      {name: " IQ - Iraq ", value: " IQ - Iraq "},
      {name: " IE - Ireland ", value: " IE - Ireland "},
      {name: " IL - Israel ", value: " IL - Israel "},
      {name: " IT - Italy ", value: " IT - Italy "},
      {name: " CI - Ivory Coast ", value: " CI - Ivory Coast "},
      {name: " JM - Jamaica ", value: " JM - Jamaica "},
      {name: " JP - Japan ", value: " JP - Japan "},
      {name: " JO - Jordan ", value: " JO - Jordan "},
      {name: " KZ - Kazakhstan ", value: " KZ - Kazakhstan "},
      {name: " KE - Kenya ", value: " KE - Kenya "},
      {name: " KI - Kiribati ", value: " KI - Kiribati "},
      {name: " KP - Korea (North) ", value: " KP - Korea (North) "},
      {name: " KR - Korea (South) ", value: " KR - Korea (South) "},
      {name: " KW - Kuwait ", value: " KW - Kuwait "},
      {name: " KG - Kyrgyz Republic ", value: " KG - Kyrgyz Republic "},
      {name: " LA - Laos ", value: " LA - Laos "},
      {name: " LV - Latvia ", value: " LV - Latvia "},
      {name: " LB - Lebanon ", value: " LB - Lebanon "},
      {name: " LS - Lesotho ", value: " LS - Lesotho "},
      {name: " LR - Liberia ", value: " LR - Liberia "},
      {name: " LY - Libya ", value: " LY - Libya "},
      {name: " LI - Liechtenstein ", value: " LI - Liechtenstein "},
      {name: " LT - Lithuania ", value: " LT - Lithuania "},
      {name: " LU - Luxembourg ", value: " LU - Luxembourg "},
      {name: " MO - Macau ", value: " MO - Macau "},
      {name: " MK - Macedonia (former Yuguslavia) ", value: " MK - Macedonia (former Yuguslavia) "},
      {name: " MG - Madagascar ", value: " MG - Madagascar "},
      {name: " MW - Malawi ", value: " MW - Malawi "},
      {name: " MY - Malaysia ", value: " MY - Malaysia "},
      {name: " MV - Maldives ", value: " MV - Maldives "},
      {name: " ML - Mali ", value: " ML - Mali "},
      {name: " MT - Malta ", value: " MT - Malta "},
      {name: " MH - Marshall Islands ", value: " MH - Marshall Islands "},
      {name: " MQ - Martinique (Fr.) ", value: " MQ - Martinique (Fr.) "},
      {name: " MR - Mauritania ", value: " MR - Mauritania "},
      {name: " MU - Mauritius ", value: " MU - Mauritius "},
      {name: " YT - Mayotte ", value: " YT - Mayotte "},
      {name: " MX - Mexico ", value: " MX - Mexico "},
      {name: " FM - Micronesia ", value: " FM - Micronesia "},
      {name: " MD - Moldova ", value: " MD - Moldova "},
      {name: " MC - Monaco ", value: " MC - Monaco "},
      {name: " MN - Mongolia ", value: " MN - Mongolia "},
      {name: " MS - Montserrat ", value: " MS - Montserrat "},
      {name: " MA - Morocco ", value: " MA - Morocco "},
      {name: " MZ - Mozambique ", value: " MZ - Mozambique "},
      {name: " MM - Myanmar ", value: " MM - Myanmar "},
      {name: " NA - Namibia ", value: " NA - Namibia "},
      {name: " NR - Nauru ", value: " NR - Nauru "},
      {name: " NP - Nepal ", value: " NP - Nepal "},
      {name: " AN - Netherland Antilles ", value: " AN - Netherland Antilles "},
      {name: " NL - Netherlands ", value: " NL - Netherlands "},
      {name: " NC - New Caledonia (Fr.) ", value: " NC - New Caledonia (Fr.) "},
      {name: " NZ - New Zealand ", value: " NZ - New Zealand "},
      {name: " NI - Nicaragua ", value: " NI - Nicaragua "},
      {name: " NE - Niger ", value: " NE - Niger "},
      {name: " NG - Nigeria ", value: " NG - Nigeria "},
      {name: " NU - Niue ", value: " NU - Niue "},
      {name: " NF - Norfolk Island ", value: " NF - Norfolk Island "},
      {name: " MP - Northern Mariana Islands ", value: " MP - Northern Mariana Islands "},
      {name: " NO - Norway ", value: " NO - Norway "},
      {name: " OM - Oman ", value: " OM - Oman "},
      {name: " PK - Pakistan ", value: " PK - Pakistan "},
      {name: " PW - Palau ", value: " PW - Palau "},
      {name: " PA - Panama ", value: " PA - Panama "},
      {name: " PG - Papua New Guinea ", value: " PG - Papua New Guinea "},
      {name: " PY - Paraguay ", value: " PY - Paraguay "},
      {name: " PE - Peru ", value: " PE - Peru "},
      {name: " PN - Pitcairn ", value: " PN - Pitcairn "},
      {name: " PL - Poland ", value: " PL - Poland "},
      {name: " PF - Polynesia (Fr.) ", value: " PF - Polynesia (Fr.) "},
      {name: " PT - Portugal ", value: " PT - Portugal "},
      {name: " PR - Puerto Rico (US) ", value: " PR - Puerto Rico (US) "},
      {name: " PS - Palestinian State ", value: " PS - Palestinian State "},
      {name: " QA - Qatar ", value: " QA - Qatar "},
      {name: " RE - Reunion (Fr.) ", value: " RE - Reunion (Fr.) "},
      {name: " RO - Romania ", value: " RO - Romania "},
      {name: " RU - Russian Federation ", value: " RU - Russian Federation "},
      {name: " RW - Rwanda ", value: " RW - Rwanda "},
      {name: " LC - Saint Lucia ", value: " LC - Saint Lucia "},
      {name: " WS - Samoa ", value: " WS - Samoa "},
      {name: " SM - San Marino ", value: " SM - San Marino "},
      {name: " SA - Saudi Arabia ", value: " SA - Saudi Arabia "},
      {name: " SN - Senegal ", value: " SN - Senegal "},
      {name: " SC - Seychelles ", value: " SC - Seychelles "},
      {name: " SL - Sierra Leone ", value: " SL - Sierra Leone "},
      {name: " SG - Singapore ", value: " SG - Singapore "},
      {name: " SK - Slovakia (Slovak Rep) ", value: " SK - Slovakia (Slovak Rep) "},
      {name: " SI - Slovenia ", value: " SI - Slovenia "},
      {name: " SB - Solomon Islands ", value: " SB - Solomon Islands "},
      {name: " SO - Somalia ", value: " SO - Somalia "},
      {name: " ZA - South Africa ", value: " ZA - South Africa "},
      {name: " GS - South Georgia and South Sandwich Islands ", value: " GS - South Georgia and South Sandwich Islands "},
      {name: " SU - Soviet Union ", value: " SU - Soviet Union "},
      {name: " ES - Spain ", value: " ES - Spain "},
      {name: " LK - Sri Lanka ", value: " LK - Sri Lanka "},
      {name: " SH - St. Helena ", value: " SH - St. Helena "},
      {name: " PM - St. Pierre & Miquelon ", value: " PM - St. Pierre & Miquelon "},
      {name: " ST - St. Tome and Principe ", value: " ST - St. Tome and Principe "},
      {name: " KN - St.Kitts Nevis Anguilla ", value: " KN - St.Kitts Nevis Anguilla "},
      {name: " VC - St.Vincent & Grenadines ", value: " VC - St.Vincent & Grenadines "},
      {name: " SD - Sudan ", value: " SD - Sudan "},
      {name: " SR - Suriname ", value: " SR - Suriname "},
      {name: " SJ - Svalbard & Jan Mayen Islands ", value: " SJ - Svalbard & Jan Mayen Islands "},
      {name: " SZ - Swaziland ", value: " SZ - Swaziland "},
      {name: " SE - Sweden ", value: " SE - Sweden "},
      {name: " CH - Switzerland ", value: " CH - Switzerland "},
      {name: " SY - Syria ", value: " SY - Syria "},
      {name: " TJ - Tadjikistan ", value: " TJ - Tadjikistan "},
      {name: " TW - Taiwan ", value: " TW - Taiwan "},
      {name: " TZ - Tanzania ", value: " TZ - Tanzania "},
      {name: " TH - Thailand ", value: " TH - Thailand "},
      {name: " TG - Togo ", value: " TG - Togo "},
      {name: " TK - Tokelau ", value: " TK - Tokelau "},
      {name: " TO - Tonga ", value: " TO - Tonga "},
      {name: " TT - Trinidad & Tobago ", value: " TT - Trinidad & Tobago "},
      {name: " TN - Tunisia ", value: " TN - Tunisia "},
      {name: " TR - Turkey ", value: " TR - Turkey "},
      {name: " TM - Turkmenistan ", value: " TM - Turkmenistan "},
      {name: " TC - Turks & Caicos Islands ", value: " TC - Turks & Caicos Islands "},
      {name: " TV - Tuvalu ", value: " TV - Tuvalu "},
      {name: " UG - Uganda ", value: " UG - Uganda "},
      {name: " UA - Ukraine ", value: " UA - Ukraine "},
      {name: " AE - United Arab Emirates ", value: " AE - United Arab Emirates "},
      {name: " UK - United Kingdom ", value: " UK - United Kingdom "},
      {name: " UY - Uruguay ", value: " UY - Uruguay "},
      {name: " UM - US Minor outlying Islands ", value: " UM - US Minor outlying Islands "},
      {name: " UZ - Uzbekistan ", value: " UZ - Uzbekistan "},
      {name: " VU - Vanuatu ", value: " VU - Vanuatu "},
      {name: " VA - Vatican City State ", value: " VA - Vatican City State "},
      {name: " VE - Venezuela ", value: " VE - Venezuela "},
      {name: " VN - Vietnam ", value: " VN - Vietnam "},
      {name: " VG - Virgin Islands (British) ", value: " VG - Virgin Islands (British) "},
      {name: " VI - Virgin Islands (US) ", value: " VI - Virgin Islands (US) "},
      {name: " WF - Wallis & Futuna Islands ", value: " WF - Wallis & Futuna Islands "},
      {name: " EH - Western Sahara ", value: " EH - Western Sahara "},
      {name: " YE - Yemen ", value: " YE - Yemen "},
      {name: " YU - Yugoslavia ", value: " YU - Yugoslavia "},
      {name: " ZR - Zaire ", value: " ZR - Zaire "},
      {name: " ZM - Zambia ", value: " ZM - Zambia "},
      {name: " ZW - Zimbabwe", value: " ZW - Zimbabwe"}
    ]
  }




